import { MediaMatcher } from '@angular/cdk/layout';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  ViewChild,
  AfterViewInit,
  HostListener, ElementRef
} from '@angular/core';
import { SideNavService } from './side-nav.service';
import { MatSidenav } from '@angular/material/sidenav';
import { AuthService } from '../../shared-modules/services/auth.service';
import {
  Router,
  NavigationEnd,
  NavigationStart,
  NavigationCancel,
  RouterOutlet
} from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { animate, query, state, style, transition, trigger } from '@angular/animations';
import { GlobalApiService } from 'src/app/shared-modules/global-api.service';
import { SocketService } from 'src/app/shared-modules/services/chat.service';
import { Event } from '../../models/side-nav.data';
import { NotifierService } from 'angular-notifier';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RestrictPlanService } from '../restrict-plan.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ResourceCacheService } from 'src/app/shared-modules/services/resource-cache.service';
import { CachedResource } from 'src/app/shared-modules/services/cached-resource';
import { runTiered } from 'src/app/shared-modules/services/tier-scheduler';
import { MatDialog } from '@angular/material/dialog';
import { RemoteControlPromptComponent } from './remote-control-prompt/remote-control-prompt.component';
import { RemoteControlInputService, RemoteControlEvent } from 'src/app/shared-modules/services/remote-control-input.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'fyt-side-nav',
  templateUrl: 'side-nav.component.html',
  styleUrls: ['side-nav.component.css'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition('expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ]),
    // Admin <=> Staff dashboard switch (see prepareRoute() below and the router-outlet binding
    // in the .html). Keyed on each route's own 'animation' route-data value (set only on the
    // 'v2' and 'staff' routes in dashboard-routing.module.ts) rather than the route's raw URL,
    // so this transition can ONLY ever fire between exactly those two dashboards - navigating
    // to/from anything else in the app (every route without that data key resolves to the same
    // 'none' fallback below, and Angular animations don't fire when a bound value doesn't
    // change) is completely unaffected, keeping this additive with zero risk to any other page.
    // Deliberately sequential (leave fades out, THEN enter fades in) rather than a
    // position:absolute overlap crossfade - avoids any chance of disturbing this app's existing
    // sticky/absolute-positioned layouts (e.g. the sticky right rail, sticky sidenav) during the
    // brief moment both route components would otherwise coexist in the DOM.
    trigger('dashboardSwitch', [
      transition('dashboardAdmin <=> dashboardStaff', [
        query(':enter', style({ opacity: 0 }), { optional: true }),
        query(':leave', [
          animate('120ms ease-out', style({ opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
          animate('160ms ease-in', style({ opacity: 1 }))
        ], { optional: true })
      ])
    ])
  ]
})
export class SideNavComponent implements OnDestroy, AfterViewInit {
  @ViewChild('snav', { static: false }) snav: MatSidenav;
  peerConnection!: RTCPeerConnection;
  // --- Remote Control (additive) ---------------------------------------
  // These fields track the WebRTC data channel and permission state for the
  // Remote Control feature layered on top of the existing Screen Share peer
  // connection above. Nothing here changes how peerConnection itself is
  // negotiated - see startScreenShare() below for the only additive touch
  // points inside that existing, working method.
  controlChannel?: RTCDataChannel;
  remoteControlState: 'idle' | 'active' | 'paused' = 'idle';
  activeScreenShareRoom: string | null = null;
  activeScreenShareAdminId: string | null = null;
  mobileQuery: MediaQueryList;
  fillerNav: any = [];
  dynamicNav: any = [];
  private _mobileQueryListener: () => void;
  isDynamicNav: boolean;
  iconUrl = '../../../assets/icons/sidenavIcons/';
  expanded: boolean;
  userData: any;
  brandName: any;
  centreName: any;
  defaultSettingModal: boolean;
  isNavLoading: boolean;
  loaderType: string;
  showSearch: any = {};
  searchInput: any;
  userName: any;
  profilePic: any;
  role: any;
  socConStat: any = false;
  minlength: any = 10;
  maxlength: any = 10;
  socket: any;
  userDetails: any;
  sendObj: any = {};
  ioConnection: any;
  popupFlag: boolean = false;
  onAction: any;
  localData: any;
  esslExist: boolean = false;
  restriction: any;
  attendanceArray: any = [];
  connected: boolean = false;
  RETRY_INTERVAL: any = 10000;
  timeout;
  globalNotifyObj: any = {};
  smsExpiryFlag: boolean = false;
  settingsData: any;
  subExpiredPupUp: boolean;
  myInputObj: any = {};
  currentActive: any = 0; // index of currently active sidenav
  brandLogo: any;
  restrictionFlag: boolean = false;
  restrictionObj: any = {};
  settingsRestrictions: any = [];
  openDoorPopupFlag: boolean = false;
  private readonly notifier: NotifierService;
  doorStatus: boolean = false;
  volume: any = "volume";
  openSubscriptionPop: boolean = false;
  contactDrawerFlag: boolean = false;
  ratingPopupFlag: boolean = false;
  @ViewChild('customTemplate', { static: true }) customNotificationTmpl;
  accessList: any = [];
  notification = 0;
  adminPlanName = "";
  planaccessList: any = {};
  dashboardIndex: any;
  isNewDashboard = false;
  // Which of Admin/Staff the "new dashboard" experience should land on - same 'gymDashboardView'
  // preference login.component.ts reads (written by new-dashboard.component.ts's
  // goToStaffDashboard()/staff-dashboard.component.ts's goToAdmin()). Defaults to Staff unless
  // the user explicitly last chose Admin. Used for every generic "go to the new dashboard" link
  // here (the nav's own Dashboard item, the brand logo, the New Dashboard toggle) - NOT for
  // staff-dashboard.component.ts's own goToAdmin() button, which is an explicit user choice, not
  // a default.
  get defaultDashboardRoute(): string {
    return localStorage.getItem('gymDashboardView') === 'admin' ? 'dashboard/v2' : 'dashboard/staff';
  }
  showBlink = true;
  showTryMe = true;
  branchId: any;
  DashboardActive: any = false;
  isBlinking = true;
  rmData: any;
  notificationFlag: boolean = false;
  biometricPopupFlag: boolean = false;
  message: any;

  // Persisted (localStorage-only, no backend) open/collapsed state for the desktop sidenav -
  // read once here so the very first [opened] binding in the template already reflects
  // whatever the user last left it as, and written back to on every user-driven (openedChange)
  // so a manual minimize/close survives a full page reload/reopen until the user manually
  // expands it again. Mobile ('over' mode) is untouched: it always starts closed regardless of
  // this value (see the [opened] binding), so it's neither read nor written while
  // mobileQuery.matches.
  private static readonly SIDEBAR_OPENED_STORAGE_KEY = 'sideNavOpened';
  sidebarOpened: boolean = localStorage.getItem(SideNavComponent.SIDEBAR_OPENED_STORAGE_KEY) !== '0';

  // Persisted (localStorage-only, no backend) hide/show state for the floating Open Door /
  // Support / Contact quick-action tabs (see the .html, right below <mat-sidenav-content>) -
  // those are fixed-position, always on top (z-index 9999999) on every page under this shell,
  // and can end up sitting over other fixed/right-aligned page content (e.g. a dashboard card's
  // own right rail). Hiding them is a pure client-side layout preference, same pattern as
  // sidebarOpened above - read once here, written back to on every toggle, so it survives a
  // reload until the user brings them back via the small restore tab.
  private static readonly FLOATS_HIDDEN_STORAGE_KEY = 'sideNavQuickActionsHidden';
  quickActionFloatsHidden: boolean = localStorage.getItem(SideNavComponent.FLOATS_HIDDEN_STORAGE_KEY) === '1';

  toggleQuickActionFloats(hidden: boolean): void {
    this.quickActionFloatsHidden = hidden;
    localStorage.setItem(SideNavComponent.FLOATS_HIDDEN_STORAGE_KEY, hidden ? '1' : '0');
  }

  // Animation state key for the router-outlet's [@dashboardSwitch] binding (see the trigger
  // definition above and the .html) - the currently-ACTIVATED route's own 'animation' route
  // data if it set one (only 'v2'/'staff' do, see dashboard-routing.module.ts), 'none'
  // otherwise. 'none' on every other route means the dashboardSwitch trigger's
  // 'dashboardAdmin <=> dashboardStaff' transition condition is never met outside those two.
  prepareRoute(outlet: RouterOutlet): string {
    return outlet?.activatedRouteData?.['animation'] || 'none';
  }

  private readonly subs = new Subscription();
  private readonly wiredKeys = new Set<string>();

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private sideNavService: SideNavService,
    private authService: AuthService,
    private router: Router,
    public sanitizer: DomSanitizer,
    public socketService: SocketService,
    public globalApiService: GlobalApiService,
    private restrictplanService: RestrictPlanService,

    // public subscription: Subscription,
    private iconRegistry: MatIconRegistry,
    private snackbar: MatSnackBar,
    private resourceCache: ResourceCacheService,
    public notifierService: NotifierService,
    private dialog: MatDialog,
    private remoteControlInput: RemoteControlInputService,
    // Reused from login.component.ts - same package, same getDeviceInfo().browser call - so
    // the Active Login Sessions list (Centres -> Screen Share) can show a real browser name.
    private deviceDetector: DeviceDetectorService) {
    this.notifier = notifierService;
    this.mobileQuery = media.matchMedia('(max-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.registerNavIcons();
    let esslAvailabel;
    this.rmData = JSON.parse(localStorage.getItem('userDetails'));
    let eData = JSON.parse(localStorage.getItem('userDetails'));
    if (eData) esslAvailabel = eData.esslSrNo
    if (esslAvailabel) {
      setInterval(() => { this.checkDoorConnetion(); }, 60000); // for check door connection after every 60 seconds
    }
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.checkAccess();
    this.subs.unsubscribe();
    // Additive - make sure a live screen-share/remote-control session
    // doesn't outlive this component.
    if (this.activeScreenShareRoom) this.notifyScreenShareEnded('component-destroyed');
  }

  // Fires on every change to the desktop sidenav's opened state - the hamburger toggle button,
  // or any other future trigger. Persists it so the collapsed/expanded state sticks across
  // reloads (see sidebarOpened's own comment above). Ignored on mobile: that sidenav is
  // 'over' mode and always meant to start closed on load, so its transient open/close while
  // navigating shouldn't overwrite the desktop preference.
  onSidenavOpenedChange(opened: boolean): void {
    if (this.mobileQuery.matches) return;
    this.sidebarOpened = opened;
    localStorage.setItem(SideNavComponent.SIDEBAR_OPENED_STORAGE_KEY, opened ? '1' : '0');
  }

  /**
   * Attaches this component's data/error handling to a shared CachedResource exactly once
   * (even if the owning method is called many times), so repeated triggers never pile up
   * duplicate subscriptions. Falls back to the last cached value instead of a stuck spinner.
   */
  private ensureWired<T>(key: string, onData: (res: T) => void, onError?: () => void): CachedResource<T> {
    const resource = this.resourceCache.get<T>(key);
    if (!this.wiredKeys.has(key)) {
      this.wiredKeys.add(key);
      this.subs.add(resource.data$.pipe(filter(res => !!res)).subscribe(onData));
      if (onError) this.subs.add(resource.error$.pipe(filter(e => !!e)).subscribe(onError));
    }
    return resource;
  }

  checkDoorConnetion() {
    let postObj = {};
    this.sideNavService.doorConnection(postObj).subscribe(res => {
      if (res.statusCode == '001') {
        this.doorStatus = true;
      } else {
        this.doorStatus = false;
      }
    })
  }

  ngAfterViewInit() {
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.isNavLoading = true;
        }
        else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel
        ) {
          this.isNavLoading = false;
          this.onSearchCardAction();
        }
      });
  }

  ngOnInit() {
    // Tier 1 (sideNav, fired below via refreshData->getNav) and Tier 2 (mySettings,
    // fired below via getSettings) run immediately at their existing call sites.
    // Tier 3 (checkAccess, sms status, update count) is deferred until Tier 1's
    // sideNav data has landed (cache or network) or 500ms, whichever comes first,
    // so it never competes with the sidebar/settings calls for a connection slot.
    runTiered({
      tier1: [],
      tier2: [],
      tier3: [
        () => this.checkAccess(),
        () => this.checkSmsStatus(),
        () => this.newUpdateCount()
      ],
      tier1Ready$: this.resourceCache.get('sideNav').data$
    });
    this.settingsRestrictions = localStorage.getItem('settings') ? JSON.parse(localStorage.getItem('settings')) : [];
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.isNewDashboard = this.userDetails.setNewDashActive

    this.planaccessList = this.userDetails.planAccess;
    this.adminPlanName = this.userDetails.adminPlanName
    this.refreshData();
    this.myInputObj = {
      'daysRemaining': this.userDetails.daysRemaining,
      'discount': this.userDetails.discount,
      'pendingBalance': this.userDetails.fytPlanPendingBalance,
      'dueDate': this.userDetails.fytPlanDueDate,
      'adminPlanId': this.userDetails.adminPlanId
    }

    const sessionSeenPopup = sessionStorage.getItem('subExpiredPopupSeen');

    // For testing: Comment out the sessionSeenPopup check if you want it to show on every refresh
    if (this.userDetails.showPopup && this.userDetails.daysRemaining > 0 && sessionSeenPopup) {

      this.subExpiredPupUp = false;
    } else {

      this.subExpiredPupUp = this.userDetails.showPopup;
      if (this.subExpiredPupUp && this.userDetails.daysRemaining > 0) {
        sessionStorage.setItem('subExpiredPopupSeen', 'true');
      }
    }
    this.onSocketInit();
    this.emmitFun();
    this.updateEssl();
    this.getSettings();
    // sound setting check
    let soundSett = localStorage.getItem('soundSetting');

    this.volume = soundSett === "false" ? "m_sound_mute.png" : "m_sound.png"
    this.checkRoute(this.router);
    this.isNewDashboard = this.userDetails.setNewDashActive || false;
    this.isBlinking = !this.isNewDashboard;
    this.checkRouteForBlinking();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkRouteForBlinking();
      });

    this.socketService.onScreenShareRequest().subscribe(({ from, room, message }) => {
      this.startScreenShare(from, room);
    });

    this.socketService.onAnswer().subscribe(async ({ answer, sender, room }) => {
      try {
        if (this.peerConnection) {
          await this.peerConnection.setRemoteDescription(new RTCSessionDescription(answer));
        }
      } catch (error) {
      }
    });

    this.socketService.onIceCandidate().subscribe(({ candidate, sender, room }) => {
      try {
        if (this.peerConnection && candidate) {
          this.peerConnection.addIceCandidate(new RTCIceCandidate(candidate));
        }
      } catch (error) {
      }
    });

    // --- Remote Control (additive) ---------------------------------------
    // Admin is asking permission to control this shared screen. Only
    // honored while there is a live screen-share session for exactly this
    // room (this.activeScreenShareRoom, set in startScreenShare()) and no
    // remote-control session is already in progress - this is the client
    // side half of the "must be an active screen-share session" validation,
    // mirrored server-side in Socket.Controller.js.
    this.socketService.onRemoteControlRequest().subscribe(({ room, from }) => {
      if (!this.peerConnection || room !== this.activeScreenShareRoom || this.remoteControlState !== 'idle') {
        return;
      }
      const dialogRef = this.dialog.open(RemoteControlPromptComponent, {
        width: '380px',
        data: { message: 'Admin is requesting remote control of your FYTrack screen.' },
        disableClose: true
      });
      dialogRef.afterClosed().subscribe((allowed: boolean) => {
        const branchId = this.userDetails.defaultSetting.defaultBranchId;
        if (allowed) {
          this.remoteControlState = 'active';
          this.remoteControlInput.showCursor();
          this.socketService.allowRemoteControl(room, branchId, from);
        } else {
          this.socketService.denyRemoteControl(room, branchId, from);
        }
      });
    });

    // Admin stopped control, or the server force-stopped it (e.g. the other
    // side disconnected) - always safe to apply even if we're already idle.
    this.socketService.onRemoteControlStop().subscribe(({ room }) => {
      if (room === this.activeScreenShareRoom) this.forceStopRemoteControl();
    });

    // The screen-share session itself ended from the other side (admin
    // closed the viewer tab, or the server detected a disconnect) - tear
    // down remote control AND the underlying call, so remote control can
    // never outlive its screen-share session.
    this.socketService.onScreenShareEnd().subscribe(({ room }) => {
      if (room === this.activeScreenShareRoom) this.endScreenShareAndControl();
    });
  }

  // --- Remote Control (additive) ---------------------------------------

  /** Target-initiated pause - control stays granted, just temporarily suspended. */
  pauseRemoteControlAsTarget(): void {
    if (this.remoteControlState !== 'active' || !this.activeScreenShareRoom) return;
    this.remoteControlState = 'paused';
    this.remoteControlInput.hideCursor();
    this.socketService.pauseRemoteControl(this.activeScreenShareRoom, this.userDetails.defaultSetting.defaultBranchId, this.activeScreenShareAdminId);
  }

  /** Target-initiated resume after a pause. */
  resumeRemoteControlAsTarget(): void {
    if (this.remoteControlState !== 'paused' || !this.activeScreenShareRoom) return;
    this.remoteControlState = 'active';
    this.remoteControlInput.showCursor();
    this.socketService.resumeRemoteControl(this.activeScreenShareRoom, this.userDetails.defaultSetting.defaultBranchId, this.activeScreenShareAdminId);
  }

  /** Target-initiated full revoke - screen share itself keeps running. */
  revokeRemoteControl(): void {
    if (!this.activeScreenShareRoom) return;
    const wasGranted = this.remoteControlState !== 'idle';
    this.forceStopRemoteControl();
    if (wasGranted) {
      this.socketService.stopRemoteControl(this.activeScreenShareRoom, this.userDetails.defaultSetting.defaultBranchId, this.activeScreenShareAdminId, 'revoked-by-target');
    }
  }

  private forceStopRemoteControl(): void {
    this.remoteControlState = 'idle';
    this.remoteControlInput.reset();
  }

  /** Notifies the admin the screen-share session ended, then cleans up locally. */
  private notifyScreenShareEnded(reason: string): void {
    if (this.activeScreenShareRoom) {
      this.socketService.endScreenShare(
        this.activeScreenShareRoom,
        this.userDetails.defaultSetting.defaultBranchId,
        this.activeScreenShareAdminId,
        reason
      );
    }
    this.endScreenShareAndControl();
  }

  /** Local-only teardown - used both when we detect the end ourselves and when told by the other side. */
  private endScreenShareAndControl(): void {
    this.forceStopRemoteControl();
    if (this.controlChannel) {
      try { this.controlChannel.close(); } catch (e) { }
      this.controlChannel = undefined;
    }
    if (this.peerConnection) {
      try { this.peerConnection.close(); } catch (e) { }
    }
    this.activeScreenShareRoom = null;
    this.activeScreenShareAdminId = null;
  }

  async startScreenShare(targetId: string, room?: string) {
    const stream = await navigator.mediaDevices.getDisplayMedia({ video: true });

    // Reuse the room the server assigned for this request when we have one, falling back to a
    // freshly generated name otherwise.
    const roomName = room || `screen-share-${this.userDetails.defaultSetting.defaultBranchId}-${Date.now()}`;

    // Join the signaling room so the relayed answer/ice-candidate events sent by the viewer
    // (the admin's Shared Screen tab) actually reach this socket.
    this.socketService.joinScreenShareRoom(roomName);

    // Additive - tracked so Remote Control's Socket.IO handshake and cleanup
    // logic know which room/admin this live session belongs to.
    this.activeScreenShareRoom = roomName;
    this.activeScreenShareAdminId = targetId;

    this.peerConnection = new RTCPeerConnection({
      iceServers: [
        { urls: 'stun:stun.l.google.com:19302' }
      ]
    });

    // --- Remote Control (additive) ---------------------------------------
    // Created BEFORE createOffer() below so it rides along in the SAME SDP
    // offer/answer exchange already happening for the video track - no
    // separate renegotiation is introduced, and nothing about the existing
    // video/ICE flow in this method is changed.
    this.controlChannel = this.peerConnection.createDataChannel('remote-control');
    // DEBUG (temporary - remove once Remote Control is confirmed working):
    // confirms the local data channel object exists and shows its readyState
    // at creation time, and again the moment it actually finishes opening -
    // 'remoteControlState' becoming 'active' (via the Socket.IO allow
    // handshake) does NOT mean this channel is open yet, so this is the only
    // way to see whether events sent by the admin can physically arrive.
    console.log('[RemoteControl] datachannel received:', this.controlChannel.readyState, '(created)');
    this.controlChannel.onopen = () => {
      console.log('[RemoteControl] datachannel received:', this.controlChannel?.readyState, '(open)');
    };
    this.controlChannel.onerror = (err) => {
      console.error('[RemoteControl] datachannel received: error', err);
    };
    this.controlChannel.onmessage = (event) => {
      console.log('[RemoteControl] received event:', event.data);
      if (this.remoteControlState === 'active') {
        try {
          const parsedEvent = JSON.parse(event.data) as RemoteControlEvent;
          console.log('[RemoteControl] applying event:', parsedEvent);
          this.remoteControlInput.apply(parsedEvent);
        } catch (e) {
          // Previously a silent empty catch - a real bug here would produce
          // zero visible symptom. Now logged so a genuine runtime failure in
          // apply() is never invisible.
          console.error('[RemoteControl] applying event: failed to apply/parse', e);
        }
      }
    };
    this.controlChannel.onclose = () => {
      console.log('[RemoteControl] datachannel received:', 'closed');
      this.forceStopRemoteControl();
    };

    // Auto-stop remote control (and the call itself) if the peer connection
    // drops, per the requirement that remote control must never outlive a
    // disconnected session.
    this.peerConnection.oniceconnectionstatechange = () => {
      const state = this.peerConnection?.iceConnectionState;
      if (state === 'disconnected' || state === 'failed' || state === 'closed') {
        this.notifyScreenShareEnded('connection-lost');
      }
    };

    stream.getTracks().forEach(track => this.peerConnection.addTrack(track, stream));

    // Additive - the browser's native "Stop sharing" control (or closing the
    // shared window/tab) ends the underlying MediaStreamTrack. Previously
    // nothing observed this, so Screen Share (and any Remote Control layered
    // on top) had no way to notice the session actually stopped.
    stream.getVideoTracks().forEach(track => {
      track.onended = () => this.notifyScreenShareEnded('stopped-by-target');
    });

    this.peerConnection.onicecandidate = (event) => {
      if (event.candidate) {
        this.socketService.sendIceCandidate(targetId, this.userDetails.defaultSetting.defaultBranchId, roomName, event.candidate);
      }
    };

    const offer = await this.peerConnection.createOffer();
    await this.peerConnection.setLocalDescription(offer);

    this.socketService.sendOffer(targetId, this.userDetails.defaultSetting.defaultBranchId, roomName, offer);
  }

  checkRouteForBlinking() {
    const currentUrl = this.router.url;
    this.isBlinking = currentUrl === '/gym/dashboard' && !this.isNewDashboard;
  }

  checkPlanRestic(functionName) {

    if (!this.planaccessList[functionName]) {
      this.restrictplanService.showUpgradeModal();
      return true
    } else return false;
  }
  checkAccess() {
    const resource = this.ensureWired<any>('checkAccess', res => {
      if (res.statusCode == '001') {
        this.accessList = res.data;
        localStorage.setItem("accessList", JSON.stringify(this.accessList));
      }
    });
    resource.load(() => this.sideNavService.checkAccess({}));
  }

  checkRoute(navItem) {
    this.openSubscriptionPop = false;
    if ((this.accessList).includes(navItem.url)) this.openSubscriptionPop = true;
  }

  toShowNotification(type, message) {
    this.notifier.show({
      type: type,
      message: message
    });
  }

  // for socket
  onSocketInit() {
    this.socketService.initializeSocketIO();
    this.ioConnection = this.socketService.getMessages().subscribe((message) => { this.getDataForPopup(message); });
    // on connect and disconnetct
    this.socketService.onEvent(Event.CONNECT).subscribe(() => { this.emmitFun(); });
    this.socketService.onEvent(Event.DISCONNECT).subscribe(() => { });
    this.socketService.getNotifications().subscribe((data) => { this.toShowNotification(data.type, data.message) });
    this.socketService.getFeedback().subscribe((data) => { this.showFeedback(data) });
    this.socketService.reLoginWhats().subscribe((data) => { this.reLoginWhats(data) })
    this.socketService.getBiometricSuggestion().subscribe((data) => { this.suggestBiometric(data) })
  }

  suggestBiometric(data) {
    this.message = data;
    this.biometricPopupFlag = true;

  }

  reLoginWhats(data) {
    if (this.router.url.includes('/gym/branches/branch')) {
      return;
    } else if (data.branchId === this.userDetails.defaultSetting.defaultBranchId) {
      // this.snackbar.open('WhatsApp session has been logged out.', '', { duration: 3000 });

      this.notificationFlag = true;
      setTimeout(() => {
        this.notificationFlag = false;
      }, 5000);
    }
  }

  closeNotification() {
    this.notificationFlag = false;
  }

  showFeedback(data) {
    this.ratingPopupFlag = true
  }

  closeFeedback() {
    this.ratingPopupFlag = false
  }

  closeBiometricFunc() {
    this.biometricPopupFlag = false;
  }

  updateEssl() {
    let userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.localData = JSON.parse(localStorage.getItem('userDetails'));
    this.esslExist = userDetails.esslSrNo ? true : false;
    this.restriction = userDetails.componentAccessRestriction;
  }

  emmitFun() {
    this.socketService.notificationConnection({
      from: this.userDetails.name,
      content: localStorage.getItem('userDetails'),
      // Additive field, read by Socket.Controller.js#notificationConnection to populate the
      // Active Login Sessions list (Centres -> Screen Share). Existing behavior for this event
      // is unchanged for any listener that ignores the field.
      browser: this.detectBrowserName()
    });
  }

  // Brave deliberately reports itself as "Chrome" in the User-Agent string (for site
  // compatibility), so ngx-device-detector - which only parses the UA - can't tell them apart.
  // Brave does inject a `navigator.brave` object synchronously at page load though, so check for
  // that first and only fall back to the UA-based guess for every other browser.
  private detectBrowserName(): string {
    try {
      if ((navigator as any).brave) {
        return 'Brave';
      }
    } catch (e) {
      // ignore - fall back to UA-based detection below
    }
    return this.deviceDetector.getDeviceInfo().browser;
  }

  getDataForPopup(data) {
    let notType = data.isActive ? "active" : "expired";
    if (notType !== 'expired' && data.plans[0].pendingAmount > 0 && new Date(data.plans[0].dueDate) < new Date()) {
      notType = "newPending"
    }
    // let notType2 = data.isActive ? "active" : "newPending";
    this.playAudio(notType);
    this.attendanceArray.push(data);
    this.sendObj = data;
    setTimeout(() => { this.attendanceArray.pop() }, 15000);
  }

  playAudio(type) {
    let soundSett = localStorage.getItem('soundSetting');
    if (soundSett !== "false") {
      let audio = new Audio();
      audio.src = `https://fytrackstorage.s3.ap-south-1.amazonaws.com/sound/${type}.wav`;
      audio.load();
      audio.play();
    }
  }

  //open door
  openDoor() {
    if (!this.doorStatus) {
      this.notifier.show({
        type: 'error',
        message: "Biometric device is disconnected, please check your biometric device's connection."
      });
      this.openDoorPopupFlag = false;
    } else {
      this.openDoorPopupFlag = true;
    }
  }

  openDoorFinal() {
    const postObj = {};
    this.sideNavService.openDoor(postObj).subscribe(res => {
      if (res.statusCode == '001') {
        this.closeOpenDoorpopup();
      }
    });
  }

  closeOpenDoorpopup() {
    this.openDoorPopupFlag = false;
  }

  refreshData() {
    this.getNav();
    this.setDefaultBranch();
  }

  setDefaultBranch() {
    this.userData = this.authService.loadUserData();
    let puData = JSON.parse(this.userData);
    this.brandLogo = puData.logo;
    this.userName = puData.name;
    this.profilePic = puData.profilePic;
    this.role = puData.role;
    let defaultSetting = puData.defaultSetting;
    this.brandName = defaultSetting?.defaultCentreName || "-";
    this.centreName = defaultSetting?.defaultBranchName || "-";
  }

  // to get the side nav from Database
  getNav() {
    const resource = this.ensureWired<any>('sideNav', res => {
      this.dynamicNav = [];
      if (res && res.Status == 'Success') {
        if (res.data && res.data.length > 0) {
          this.dynamicNav = res.data;
          // let newDashboardActive = true;
          if (this.isNewDashboard == true) {
            // Update URL for dashboard uniqueName
            this.dynamicNav = this.dynamicNav.map(item => {
              if (item.uniqueName === 'dashboard' && this.isNewDashboard == true) {
                return {
                  ...item,
                  url: '/gym/' + this.defaultDashboardRoute
                };
              }
              return item;
            });
          }
        }
      }
    });
    resource.load(() => this.sideNavService.getsideNav());
  }

  // get settings data
  getSettings() {
    const resource = this.ensureWired<any>('mySettings', res => {
      if (res && res.Status == 'Success') {
        this.settingsData = res.data;

        localStorage.setItem("settings", JSON.stringify(this.settingsData));
      }
    });
    resource.load(() => this.sideNavService.accessSettings({}));
  }

  checkSmsStatus() {
    const resource = this.ensureWired<any>('smsLimit', res => {
      if (res && res.Status == 'Success') {
        this.globalNotifyObj.message = res.data.message;
        this.globalNotifyObj.secondsToDisplay = res.data.secondsToDisplay;
        this.globalNotifyObj.type = res.data.type;
        this.smsExpiryFlag = true;
      }
    });
    resource.load(() => this.sideNavService.smsLimitFunction({}));
  }

  // ============ Sidebar nav icons (new SVG set) ============
  // Replaces the old two-PNG-per-item approach (nav.imgUrl / nav.imgUrlWhite, both backend-
  // provided filenames with color baked into the raster image - still used as a fallback below
  // for any nav item this new set doesn't cover) with one currentColor-filled SVG per item,
  // registered via Angular Material's icon registry (see registerNavIcons() below) and rendered
  // through <mat-icon [svgIcon]="..."> in the .html. Because it's real inline SVG (not an
  // <img>), its fill inherits whatever CSS `color` is set on it - the active-route color flip
  // (.fyt-active-route in fyt-custom-global.css forces color:#ffffff !important) turns the icon
  // white for free, with no separate "white" file and no currentActive===i icon-swap logic
  // needed the way the old PNG pair required.
  //
  // Keyed by a slugified nav name (lowercase, spaces -> hyphens - e.g. "Add On Services" ->
  // "add-on-services") rather than nav.imgUrl, since imgUrl is backend-controlled and has no
  // reason to match these new filenames. Colors are this icon set's own palette (see
  // sidebar-icons/README.md it shipped with).
  private static readonly NAV_ICON_COLORS: { [slug: string]: string } = {
    'dashboard': '#f68b1e',
    'enquiry': '#2fa05a',
    'members': '#3b82f6',
    'batches': '#e0723c',
    'attendance': '#e0b021',
    'plans': '#e0384f',
    'staff': '#3b82f6',
    'appointments': '#2f8ad0',
    'bookings': '#e0b021',
    'communications': '#d94f8c',
    'expenses': '#e0384f',
    'accounts': '#2fa05a',
    'add-on-services': '#7c4dd0',
    'schedule': '#d94f8c',
    'analytics': '#2f8ad0',
    'reports': '#2fa05a',
    'equipments': '#d94f8c',
    'profile': '#6067ce',
    // Not wired to any current nav item - kept registered in case a future menu item needs them.
    'follow-ups': '#0b8499',
    'payments': '#12a05a'
  };

  // Registers every icon in NAV_ICON_COLORS exactly once (constructor - see below), independent
  // of whatever dynamicNav the backend returns - these are a fixed static asset list, not
  // per-nav-item data, so MatIconRegistry.addSvgIcon()'s sanitizer work never re-runs per
  // change-detection cycle the way calling it directly from the template per *ngFor item would.
  private registerNavIcons(): void {
    Object.keys(SideNavComponent.NAV_ICON_COLORS).forEach(slug => {
      this.iconRegistry.addSvgIcon(slug, this.sanitizer.bypassSecurityTrustResourceUrl(this.iconUrl + slug + '.svg'));
    });
  }

  // Template-side lookup (cheap string ops only, safe to call per *ngFor item on every CD
  // cycle) - null when this nav item's name doesn't match any registered icon, so the .html
  // can fall back to the original nav.imgUrl/imgUrlWhite <img> rendering unchanged.
  getNavIconSlug(name: string): string | null {
    if (!name) return null;
    const slug = name.trim().toLowerCase().replace(/\s+/g, '-');
    return SideNavComponent.NAV_ICON_COLORS.hasOwnProperty(slug) ? slug : null;
  }

  getNavIconColor(slug: string): string {
    return SideNavComponent.NAV_ICON_COLORS[slug] || '#3d4553';
  }

  // to logOut
  logOutUser() {
    this.authService.logout();
  }

  // to navigate
  navigateTo(navItem, index) {

    this.checkRoute(navItem);
    this.currentActive = index;
    if (navItem.children && navItem.children.length > 0) this.expanded = !this.expanded;
    if (this.mobileQuery.matches) this.snav.close();
  }

  showMyProfile() {
    this.router.navigate(['/gym/profile']);
  }

  soundOnOff() {
    let soundSett = localStorage.getItem('soundSetting');
    let keyToStore = (soundSett === "false") ? "true" : "false";
    this.volume = keyToStore === "false" ? "m_sound_mute.png" : "m_sound.png";
    localStorage.setItem('soundSetting', keyToStore);
  }

  supportTo() {
    localStorage.setItem('back_url', this.router.url);
    this.router.navigate(['/gym/support']);
  }

  // to open the details
  onModalAction(event) {
    this.defaultSettingModal = true;
  }

  onCardAction(event) {
    this.defaultSettingModal = false;
    this.restrictionFlag = false;
    if (event.page === 'defaultSettings') {
      this.refreshData();
    }
  }

  openGlobeSearchBox(event?: any) {

    if (this.checkPlanRestic('gobalSearch')) return
    if (!event) return;
    this.showSearch.isOpen = true;
    this.showSearch.boxClass = 'slideInDown';
  }

  onSearchCardAction(event?: any) {
    this.showSearch.boxClass = 'slideOutUp';
    setTimeout(() => {
      this.showSearch.isOpen = false;
      this.searchInput = '';
    }, 1000);
  }

  onNotifyCardAction(event?: any) {
    this.smsExpiryFlag = false;
    this.attendanceArray.pop();
  }

  // for key escape event binding
  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    this.onSearchCardAction();
  }


  dynamicLength(searchInput1) {
    if (isNaN(this.searchInput)) {
      this.minlength = 1;
      this.maxlength = 25;
    } else {
      this.minlength = 10;
      this.maxlength = 10;
    }
  }

  onCancelCard(event) {
    if (event.flag == true) {
      this.refreshData();
    }
    this.subExpiredPupUp = false;
  }

  restrict() {
    this.restrictionFlag = true;
  }

  goToSettings() {
    let localDetails = JSON.parse(localStorage.getItem("userDetails"));
    let branchDetails = localDetails.defaultSetting;
    this.router.navigate([`/gym/branches/branch/${branchDetails.defaultBranchId}/settingFlag`]);
  }

  goToNotification() {
    this.router.navigate(['/gym/communication/notifications']);
  }

  goToNewTab() {
    let currentUrl = window.location.href.split("#");
    window.open(`/#${currentUrl[1]}`);
  }

  openContactView() {
    this.contactDrawerFlag = this.contactDrawerFlag ? false : true;
  }

  newUpdates() {
    if (this.router.navigate(['/gym/support'])) localStorage.setItem('accountsTabIndex', '2');
  }

  newUpdateCount() {
    const resource = this.ensureWired<any>('gymUpdatesCount', res => {
      if (res && res.Status == 'Success') {
        this.notification = res.data.count ? res.data.count : 0
      }
    });
    resource.load(() => this.sideNavService.getUpdates());
  }

  toggleDashboard() {
    this.isNewDashboard = !this.isNewDashboard;
    this.checkRouteForBlinking();
    this.newDashboardActive();
  }


  newDashboardActive() {
    let postObj = {
      branchId: this.userDetails.defaultSetting.defaultBranchId,
      newDashboardActive: this.isNewDashboard
    };
    this.sideNavService.newDashboardActive(postObj).subscribe(res => {
      if (res.statusCode == '001') {
        this.userDetails.setNewDashActive = this.isNewDashboard
        localStorage.setItem('userDetails', JSON.stringify(this.userDetails))
        this.getNav();
        const route = this.isNewDashboard ? 'gym/' + this.defaultDashboardRoute : 'gym/dashboard';
        this.router.navigate([route]);
      } else {
      }
    })
  }
}
